import { Language, Provider } from '@cloud-native/workflows-engine'
import { JobType } from '../../jobs/types'

export const paramsToJobPayload = (params: {
  region?: string
  provider: Provider
  language?: Language
  workflowId: string
  query: string
}) => {
  const options: Record<string, unknown> = { language: params.language ?? Language.SQL }

  if (params.region && params.provider === Provider.BigQuery) {
    options.location = params.region
  }

  return {
    query: params.query,
    metadata: {
      workflowId: params.workflowId,
      type: JobType.Workflow
    },
    options
  }
}
